import { USONBOARDING } from '../actionTypes';

const initialState = {
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case USONBOARDING.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
